<template>
  <el-menu mode="vertical" theme="dark" unique-opened :default-active="$route.path">
    <div :class="{ 'logo-name': sidebar.opened, 'logo-img': !sidebar.opened}">
      <span v-if="sidebar.opened">
        <span v-if="baseInfo">青柠微影{{getUserTitle}}管理后台</span>
        <span v-if="!baseInfo">青柠后台</span>
      </span>
      <span v-if="!sidebar.opened">
        <img class="logoImage" src="../../../static/image/logo.png" alt="">
      </span>
    </div>
    <!-- {{routes[6].children[0].children}} -->
    <sidebar-item :routes="routes"></sidebar-item>

  </el-menu>
</template>

<script>
import { mapGetters } from "vuex"; //获取vuex数据
import SidebarItem from "./SidebarItem";
import EnvBase from "@/env.js";
import SvrApi from "@/svrapi.js";
import { asyncCeshi, constantRouterMap } from "@/router";
import { agencyQnbarRequest } from '@/utils'
const getStoreStatus = params => agencyQnbarRequest('getStoreStatus',params)

var PT = EnvBase.PT;
let store_sn
let SHOW
export default {
  data: function() {
    return {
      user_title: "",
      username: "",
      routes: [],
      baseInfo: false,
      group_id: "",
    };
  },
  components: { SidebarItem },
  computed: {
    ...mapGetters(["sidebar", "getUserTitle"]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  created: function() {
    store_sn = (JSON.parse(localStorage.getItem('user_data')) || {}).agent_id
    getStoreStatus({store_sn}).then(res => {
      res.data.interval_status === '1' ? SHOW = false : SHOW = true
    })
    var self = this;
    // console.log(self)
    // self.routes = self.$router.options.routes;
    // return;
    // console.log("8888888888888888888888888888");
    PT.apiClient.query("bz-mix/bz/get-base-info", "", function(rsp) {
      if (rsp.code == 0) {
        // console.log("router请求");
        localStorage.setItem("user_data", JSON.stringify(rsp.data));
        self.$store.commit("SET_ROUTE", rsp.data);
        var mythisroutes = JSON.parse(
          JSON.stringify(self.$router.options.routes)
        );
        //租赁权限
        var lease_type = JSON.parse(localStorage.getItem('user_data')).lease_type
        // //注释权限
        // self.routes = mythisroutes;
        // return;
        var userInfo = JSON.parse(localStorage.getItem("user_data"));
        var identity = JSON.parse(localStorage.getItem("identity"));
        var user_all = JSON.parse(localStorage.getItem("user_all"));
        var is_open = userInfo.is_open;
        var interface_set = userInfo.interface_set;
        // console.log(userInfo);
        //基本信息显示隐藏
        if (userInfo.agentType == 1 || userInfo.agentType == 2) {
          $("title").html("青柠后台管理系统");
          self.baseInfo = false;
        } else {
          $("title").html("青柠微影商户管理系统");
          self.baseInfo = true;
        }
        var newarr = [];

        //获取特殊权限
        PT.apiClient.query(SvrApi.specialCompets, {}, function(rsp) {
          if (rsp.code == 0) {
            let user_data = JSON.parse(localStorage.getItem("user_data"));
            let group_id = user_data.group_id;
            // console.log(rsp);
            if (rsp.data.length <= 0) {
            } else {
              user_all = rsp.data;
            }
            for (let i = 0, ilen = mythisroutes.length; i < ilen; i++) {
              //一级菜单
              //首页
              if (mythisroutes[i].path == "/homepage") {
                newarr.push(mythisroutes[i]);
              } else if (
                user_all.indexOf("store_base_modul") >= 0 &&
                mythisroutes[i].path == "/storeMat"
              ) {
                //门店管理
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //界面设置
                  if (
                    user_all.indexOf("store_interface_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "/storeMat/interfaceMat"
                  ) {
                    //界面设置子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf("store_interface_1_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "Interfaceone" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("store_interface_2_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "Interfacetwo" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "Interfacethree" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "Interfacefour" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                        else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "Interfacefive" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "InterfaceSix" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "InterfaceSeven" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "InterfaceEight" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                       else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "hotelIntroduction" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                       else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "technicianService" && group_id != 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "examine"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      // meituanhotel
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path ==
                        "meituanhotel" && group_id == 2
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                      else if (
                        user_all.indexOf("store_interface_message_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "Interfacetnews"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("store_interface_settlement_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "Interfacetwosts"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("store_interface_ctrl_pwd_mgr") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "consolepwd"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("store_interface_welcome_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "welcome"
                      ) {
                        console.log('我有权限')
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                        console.log("threearr", threearr)
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);

                    console.log(JSON.parse(JSON.stringify(myarr)))
                    console.log(mythisroutes)
                  } else if (
                    //员工管理
                    user_all.indexOf("store_staff_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "/storeMat/employeeMat"
                  ) {
                    //员工管理子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf("store_staff_account_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "staff_list"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("store_staff_role_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "role_list"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    user_all.indexOf("store_opinion_list") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "opinionMat/opinion_list"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    user_all.indexOf("store_room_list") >= 0 &&
                    mythisroutes[i].children[index].path == "roomMat/room_list"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    user_all.indexOf("store_log_list") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "journalMat/journal_list"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    user_all.indexOf("store_function_pub_list") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "functionMat/function_list"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
                user_all.indexOf("copyright_base_modul") >= 0 &&
                mythisroutes[i].path == "/demandMat"
              ) {
                //点播付费
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //点播订单
                  if (
                    user_all.indexOf("copyright_order_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "demandOdr/demandOdr_list"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
                user_all.indexOf("finance_base_modul") >= 0 &&
                mythisroutes[i].path == "/financeMat"
              ) {
                //财务数据
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //财务结算
                  if (
                    user_all.indexOf("finance_settle_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "/financeMat/financial_set"
                  ) {
                    //财务结算子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf("finance_settle_copyright_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "demand_set"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("finance_settle_shopping_list") >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "shopping_set"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    //营收统计
                    user_all.indexOf("finance_revenue_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "/financeMat/revenue_sts"
                  ) {
                    //营收统计子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf("finance_revenue_copyright_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "demand_rve"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("finance_revenue_shopping_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "shopping"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
                user_all.indexOf("projector_shopping_base_modul") >= 0 &&
                mythisroutes[i].path == "/commodityshpMat"
              ) {
                //商品购物
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //商品配送
                  if (
                    user_all.indexOf("projector_shopping_distribution_mgr") >=
                      0 &&
                    mythisroutes[i].children[index].path ==
                      "/commodityshpMat/commoditydsn"
                  ) {
                    //商品配送子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf(
                          "projector_shopping_distribution_list_list"
                        ) >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "distribution_list"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf(
                          "projector_shopping_distribution_ok_list"
                        ) >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "distribution_record"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf(
                          "projector_shopping_distribution_not_list"
                        ) >= 0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "wait_distribution"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    //商品管理
                    user_all.indexOf("projector_shopping_goods_relation_mgr") >=
                      0 &&
                    mythisroutes[i].children[index].path ==
                      "/commodityshpMat/commoditymat"
                  ) {
                    //商品管理子路由
                    var threearr = [];
                    for (
                      let k = 0,
                        klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ) {
                      if (
                        user_all.indexOf("projector_shopping_goods_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "commodity_list"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        user_all.indexOf("projector_shopping_category_list") >=
                          0 &&
                        mythisroutes[i].children[index].children[k].path ==
                          "commodity_class"
                      ) {
                        threearr.push(
                          mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    //商品订单
                    user_all.indexOf("projector_shopping_order_list") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "/commodityshpMat/commodityodr"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
                user_all.indexOf("bar_tech_service_fee_moudle") >= 0 &&
                mythisroutes[i].path == "/storeYb"
              ) {
                //影吧付费
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //扫码支付
                  if (
                    user_all.indexOf("bar_tech_service_fee_pay_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "scavengingPayment/payment"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    user_all.indexOf("bar_tech_service_fee_record_mgr") >= 0 &&
                    mythisroutes[i].children[index].path ==
                      "payRecord/recordList"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
                // 租赁管理
                mythisroutes[i].path == "/leaseManagement" && 
                lease_type != 0
              ) {
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //租赁二
                  if( 
                    mythisroutes[i].children[index].path ==
                    "/lease" && 
                    lease_type == 2
                   ){
                    var threearr = [];
                    for(
                      let k = 0,
                      klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ){
                      if (
                        mythisroutes[i].children[index].children[k].path ==
                        "device"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "useRecord"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "payRecord"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "disbuteRecords"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "roomRental" && SHOW === true
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if(
                    //租赁三
                    mythisroutes[i].children[index].path ==
                    "/lease3" && 
                    lease_type == 3
                  ){
                    var threearr = [];
                    for(
                      let k = 0,
                      klen = mythisroutes[i].children[index].children.length;
                      k < klen;
                      k++
                    ){
                      if (
                        mythisroutes[i].children[index].children[k].path ==
                        "roomAuthorization"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "authorizationRecords"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      } else if (
                        mythisroutes[i].children[index].children[k].path ==
                        "dataStatistics"
                      ) {
                        threearr.push(
                            mythisroutes[i].children[index].children[k]
                        );
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  }

                }
                mythisroutes[i].children = myarr;
                //添加到菜单置顶
                newarr.unshift(mythisroutes[i]);
              } else if (
                //售后系统
                mythisroutes[i].path == "/afterSalesManage"
              ) {
                 var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //扫码支付
                  if (
                    mythisroutes[i].children[index].path ==
                    "repairOrder"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    mythisroutes[i].children[index].path ==
                    "repairOrderAdd"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (
                    mythisroutes[i].children[index].path ==
                    "repairOrderDetail"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } 
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              }else if(
                //游戏管理
                mythisroutes[i].path == "/gameManager"
              ) {
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  //扫码支付
                  if (
                    mythisroutes[i].children[index].path ==
                    "flowOrder"
                  ) {
                    myarr.push(mythisroutes[i].children[index]);
                  } 
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if(
                //通用应用
                mythisroutes[i].path == "/currencyApp"
              ){
                var myarr = [];
                for (
                  let index = 0, indexlen = mythisroutes[i].children.length;
                  index < indexlen;
                  index++
                ) {
                  if(
                  //通用应用
                    mythisroutes[i].children[index].path ==
                    "generalApp"
                  ){
                    myarr.push(mythisroutes[i].children[index]);
                  } else if(
                    // 应用卸载
                    mythisroutes[i].children[index].path ==
                    "appUninstall"
                  ){
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              }
            }
            self.routes = newarr;
            var userInfo = JSON.parse(self.commonGetLocalDataNew("user_data"));
            var checkData = {
              store_sn : userInfo.agent_id
            };
            PT.apiClient.query(SvrApi.byhCheck, checkData, function(res) {
              if (res.code == 0) {
                if(res.data.store_sn){
                  self.routes = newarr;
                }else{
                  // self.routes[4].children[0].children.pop();
                }
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          } else {
            self.$alert(rsp.msg, "提示");
          }
        });
      } else {
        alert("获取用户信息错误！!");
      }
    });
  },
  watch: {
    username: {
      handler() {
        // console.log("数据变化")
        // console.log(this.username)
        // console.log(this.$router.options.routes)
        // this.$router.options.routes=[];
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu {
  min-height: 100%;
}
.logo-name {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: center;
  color: #c4d0d9;
}
.logo-img {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: left;
  color: #c4d0d9;
}
.logoImage {
  height: 32px;
  margin-left: 17px;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?db0fcb82